import React from 'react'
import { useTranslation } from 'react-i18next'

const OptionDropdown = ({productOptions, selectedOptionInModel, selection, selectedOption, skus}) => {
  //new component - Display of product variants as dropdowns
  const {t} =useTranslation()
  return (
    <div className="d-flex flex-column">
      {productOptions.length > 0 &&
        productOptions.map(({ optionGroupName, options, optionGroupID, optionGroupCode }) => {
          const selectedOptionCode = selection[optionGroupCode] || 'select'
          return (
            <div className="form-group pe-4 mb-4" key={optionGroupID}>
              <div className="d-flex justify-content-between align-items-center pb-1">
                <label className="font-weight-medium" htmlFor={optionGroupID}>
                  {optionGroupName}
                </label>
              </div>
              <select
                className="custom-select rounded-3 w-50"
                required
                value={selectedOptionCode}
                id={optionGroupID}
                onChange={e => {
                  if (selectedOptionInModel) {
                    selectedOptionInModel(optionGroupCode, e.target.value)
                  } else {
                    selectedOption(skus, optionGroupCode, e.target.value, selection)
                  }
                }}
              >
                {selectedOptionCode === 'select' && (
                  <option className={`option nonactive`} value="select">
                    {t('frontend.product.select')}
                  </option>
                )}
                {options &&
                  options.map(option => {
                    console.log(option.available)
                    return (
                      <option className={`option ${option.active ? 'active' : 'nonactive'} ${!option.available && 'option-na'}`} key={option.optionID} value={option.optionCode}>
                        {option.optionName}
                      </option>
                    )
                  })}
              </select>
            </div>
          )
        })}
    </div>
  )
}

export { OptionDropdown }